import { connect } from 'react-redux';
import actions from 'public/redux/Questionnaires/actions';
import Questionnaire from './QuestionnairePreview';

const mapStateToProps = ({ QuestionnairePreview }) => QuestionnairePreview;

const mapDispatchToProps = {
  fetchOne: actions.fetchPreview,
  clearOne: actions.clearPreview,
};

// connect with redux
export default connect(mapStateToProps, mapDispatchToProps)(Questionnaire);
